import React from 'react'
import classes from './FullWidthTitle.module.scss'

function FullWidthTitle(props){
    let fullWidthContent = props.content;

	return (
		<section className={classes.FullWidthTitle}>
            <div className={`container`}>
                <div className={`row`}>
                    <h3 className={classes.FullWidthTitle__title}>{fullWidthContent}</h3>
                </div>
            </div>
        </section>
		
	)
}

export default FullWidthTitle